export { SearchesAndRequestDynamicCardAreaName } from './constants';
export * from './SearchesAndRequestDynamicCard';
